import React,{useState} from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { hooks } from "../../studentportal-sdk";
import { emailrgx } from "../../constant";
import {Link} from 'react-router-dom'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { banner } from "../../components/imagepath";
import { Eye, EyeOff } from "react-feather/dist";


const schema = yup.object({
  email: yup
    .string()
    .matches(emailrgx, "Email is required")
    .required("Email is required")
    .trim(),
  password: yup
    .string()
    .min(6)
    .max(100)
    .required("Password is required")
    .trim(),
});

const Login = (props) => {

  const {
    /**
     * authentication service
     */
    authService: {
      action: { userAccountSignIn },
    },
    /**
     * utility and config service
     */
    utilityAndConfigService: {
      store: { loading },
    },
  } = props;

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {

    userAccountSignIn({
      email: data.email,
      password: data.password,
    });
  };

    const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };



  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-left">
                <img className="img-fluid" src={banner} alt="Logo" />
              </div>
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Welcome to the Discipleship Training Portal</h1>

                  <h2>Sign in</h2>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label>
                        Email <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="email"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <input
                            className={`form-control  ${
                              errors?.email ? "error-input" : ""
                            }`}
                            type="text"
                            value={value}
                            onChange={onChange}
                            autoComplete="false"
                            placeholder="example@gmail.com"
                          />
                        )}
                        // defaultValue=""
                      />
                      <small>{errors?.email?.message}</small>
                      <span className="profile-views">
                        <i className="fas fa-user-circle" />
                      </span>
                    </div>
                    <div className="form-group">
                      <label>
                        Password <span className="login-danger">*</span>
                      </label>

                      <Controller
                        name="password"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <div className="pass-group">
                            <input
                              type={passwordVisible ? "password" : "text"}
                              className={`form-control  ${
                                errors?.password ? "error-input" : ""
                              }`}
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                              placeholder="password"
                            />
                          </div>
                        )}
                        // defaultValue="Aj@123456"
                      />
                      <small>{errors?.password?.message}</small>
                      <span
                        className="toggle-password"
                        onClick={togglePasswordVisibility}
                      >
                        {passwordVisible ? (
                          <EyeOff className="react-feather-custom" />
                        ) : (
                          <Eye className="react-feather-custom" />
                        )}
                      </span>
                    </div>
                    <div className="forgotpass">
                      <div className="remember-me">
                        <label className="custom_check mr-2 mb-0 d-inline-flex remember-me">
                          {" "}
                          Remember me
                          <input type="checkbox" name="radio" />
                          <span className="checkmark" />
                        </label>
                      </div>
                      <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                    <div className="form-group">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                        disabled={loading.active}
                      >
                        {!loading.active && "Login"}
                                  {loading.active &&
                                    loading.internalLoading &&
                                    ".....loading"}
                      </button>
                    </div>
                  </form>
                  {/* {message && <p>{message}</p>} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
  /* eslint-disable */
export default (props) => <Login  {...hooks.authentication(props)}/>;
